export default __webpack_public_path__ + "static/media/clinical_trials.88e6ea25.png";